import React, { Component } from "react";
import { Navbar, Nav } from "react-bootstrap";
import Logo from "../assets/logo_white.png";

import { Link } from "react-router-dom";

import Web3 from "web3";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import toastr from "toastr";

class Header extends Component {
  constructor(props) {
    super(props);
    toastr.options.preventDuplicates = true;

    this.state = {
      connectButtonText: this.getConnectButtonText(),
      account: props.state.account,
      showDisconnectModal: false,
    };
  }

  WasConnected = localStorage.getItem("IsConnected") === "1";
  IsMetaMask = localStorage.getItem("IsMetaMask") === "1";

  componentDidMount() {
    if (this.WasConnected) {
      this.connectWallet();
    }
  }

  formatAddress(address) {
    if (address === null) return "";
    return (
      address.substr(0, 4) +
      "****" +
      address.substr(address.length - 4, address.length)
    );
  }
  getConnectButtonText = () => {
    //console.log("Conneceted", this.props.state.connected);
    //console.log("Account", this.props.state.account);
    if (this.props.state.connected) {
      if (this.props.state.account != null) {
        return this.formatAddress(this.props.state.account);
      } else {
        return "Connecting...";
      }
    } else {
      return "Connect Wallet";
    }
  };

  onAccountChanged = (accounts) => {
    if (accounts.length > 0) {
      if (this.props.state.account !== accounts[0]) {
        this.props.updateDappStatus(
          true,
          accounts[0],
          this.props.state.provider
        );
        toastr.info("Account has been switched.");
      }
    } else {
      this.props.updateDappStatus(false, null, this.props.state.provider);
      localStorage.setItem("IsConnected", "0");
      toastr.warning("Disconnected!");
    }
    //window.location.reload();
  };

  onChainIdChanged = (chainId) => {
    this.props.setChainId(chainId);
    if (this.props.isWrongChainSelected(chainId)) {
      //this.trySwitchNewtork();
      toastr.error(this.props.config.name + " is not selected!");
    }
    // window.location.reload();
  };

  onConnect = (info) => {
    console.log("Info", info);
  };

  onDisconnect = (code, reason) => {
    this.props.updateDappStatus(false, null, null);
    localStorage.setItem("IsConnected", "0");
    console.log("Error", code, reason);
  };

  trySwitchNewtork = async (provider) => {
    try {
      await provider.request({
        method: "wallet_switchEthereumChain",
        params: [{ chainId: this.props.config.chainIdHex }],
      });
    } catch (error) {
      if (error.code === 4902) {
        try {
          await provider.request({
            method: "wallet_addEthereumChain",
            params: [
              {
                chainId: this.props.config.chainIdHex,
                chainName: this.props.config.name,
                rpcUrls: [this.props.config.rpcUrl],
                blockExplorerUrls: [this.props.config.explorerUrl],
                nativeCurrency: {
                  name: "BNB",
                  symbol: "BNB",
                  decimals: 18,
                },
              },
            ],
          });
          return;
        } catch (addError) {
          console.log(addError);
        }
      } else {
        // mobile device?
        const chainId = await provider.request({ method: "eth_chainId" });
        this.props.setChainId(chainId);
        if (this.props.isWrongChainSelected(chainId)) {
          toastr.error(this.props.config.name + " is not selected!");
          this.setState({
            isWrongChainSelected: true,
          });
        }
        return;
      }
      console.log(error);
    }
  };

  connectWallet = async () => {
    if (this.props.state.connected) {
      this.setState({
        showDisconnectModal: true,
      });
      return;
    }

    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider, // required
        options: {
          //infuraId: "9aa3d95b3bc440fa88ea12eaa4456161", // required
          rpc: {
            1: "https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161",
            56: "https://bsc-dataseed.binance.org",
            97: "https://data-seed-prebsc-1-s1.binance.org:8545",
          },
          qrcodeModalOptions: {
            mobileLinks: [
              "trust",
              "metamask",
              "safepal",
              "ledger",
              "atomic",
              "rainbow",
              "argent",
              "imtoken",
              "pillar",
            ],
          },
        },
      },
    };

    const web3Modal = new Web3Modal({
      network: "mainnet", // optional
      cacheProvider: false, // optional
      providerOptions, // required
    });

    let provider = null;

    if (this.WasConnected && this.IsMetaMask) {
      provider = window.ethereum;
    } else {
      provider = await web3Modal.connect();
    }
    const web3 = new Web3(provider);

    // Subscribe to accounts change
    provider.on("accountsChanged", this.onAccountChanged);

    // Subscribe to chainId change
    provider.on("chainChanged", this.onChainIdChanged);

    // Subscribe to provider connection
    provider.on("connect", this.onConnect);

    // Subscribe to provider disconnection
    provider.on("disconnect", this.onDisconnect);

    const acct = (await web3.eth.getAccounts())[0];

    if (this.WasConnected && this.IsMetaMask && acct === undefined) {
      this.WasConnected = false;
      localStorage.setItem("IsConnected", "0");
      this.connectWallet();
      return;
      //window.location.reload();
    } else {
      this.props.updateDappStatus(true, acct, provider);

      this.trySwitchNewtork(provider);

      toastr.success("Connected!");

      localStorage.setItem("IsConnected", "1");
      if (provider === window.ethereum) {
        this.IsMetaMask = true;
        localStorage.setItem("IsMetaMask", "1");
      } else {
        this.IsMetaMask = false;
        localStorage.setItem("IsMetaMask", "0");
      }
    }
  };

  copyAddress = () => {
    navigator.clipboard.writeText(this.props.state.account);
    toastr.info("Address copied to clipboard.");
  };

  viewOnExplorer = () => {
    window.open("https://bscscan.com/address/" + this.props.state.account);
  };

  doDisconnect = () => {
    this.props.updateDappStatus(false, null, null);
    if (this.props.state.provider.close) {
      this.props.state.provider.close();
    }
    localStorage.setItem("IsConnected", "0");
    toastr.success("Disconnected!");
  };

  render() {
    return (
      <>
        <Navbar bg="dark" expand="md" variant="dark" sticky>
          <div className="container-fluid">
            <Link className="navbar-brand d-flex align-items-center" to="/">
              <img
                src={Logo}
                height={60}
                alt="Shieldnetwork"
                className="me-2"
              />
            </Link>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto mb-2 mb-lg-0">
                <div className="nav-link">
                  {this.props.state.connected &&
                  !this.props.state.isWrongChainSelected ? (
                    <button
                      className="btn btn-primary connected nav-link w-100"
                      onClick={this.connectWallet}
                      data-bs-toggle="modal"
                      data-bs-target="#accountInfo"
                      aria-controls="accountInfo"
                    >
                      {this.getConnectButtonText() +
                        " - " +
                        parseFloat(this.props.state.accountBalance) +
                        " BNB"}
                    </button>
                  ) : null}
                  {!this.props.state.connected &&
                  !this.props.state.isWrongChainSelected ? (
                    <button
                      className="btn btn-primary nav-link w-100"
                      onClick={this.connectWallet}
                    >
                      <i className="fas fa-wallet me-2" aria-hidden="true"></i>
                      {this.getConnectButtonText()}
                    </button>
                  ) : null}
                  {this.props.state.isWrongChainSelected ? (
                    <button
                      className="btn btn-danger nav-link w-100"
                      onClick={() =>
                        toastr.error(
                          this.props.config.name + " is not selected!"
                        )
                      }
                    >
                      <i className="fas fa-exclamation me-2"></i>
                      Wrong Network
                    </button>
                  ) : null}
                </div>
                <div className="nav-link">
                  <Link to={"/projects"} className="btn btn-primary nav-link">
                    <i className="fab fa-hotjar me-2" aria-hidden={true}></i>
                    Projects
                  </Link>
                </div>
                <div className="nav-link">
                  <a href="/stake" target="_blank" rel="noreferrer" className="btn btn-primary nav-link">
                    <i className="fas fa-layer-group me-2" aria-hidden={true}></i>
                    Stake
                  </a>
                </div>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Navbar>
        {/* <nav
          id="PPNavbar"
          className="navbar navbar-expand-md navbar-dark bg-black"
        >
          <div className="container-fluid">
            <Link className="navbar-brand d-flex align-items-center" to="/">
              <img
                src={Logo}
                height={60}
                alt="Shieldnetwork"
                className="me-2"
              />
            </Link>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link to="/projects" className="nav-link">
                    <i className="fa fa-fire me-2" aria-hidden={true}></i>
                    PROJECTS
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <a
                    className="nav-link dropdown-toggle"
                    href="#"
                    id="navbarDropdown"
                    role="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    BUY
                  </a>
                  <ul
                    className="dropdown-menu"
                    aria-labelledby="navbarDropdown"
                  >
                    <li>
                      <a
                        className="dropdown-item"
                        target="_blank"
                        rel="noreferrer"
                        href="https://pancakeswap.finance/swap?outputCurrency=0xf2e00684457de1a3c87361bc4bfe2de92342306c"
                      >
                        <img
                          alt=""
                          src={Pancake}
                          height="20"
                          aria-hidden={true}
                          className="me-2"
                        />
                        PANCAKE SWAP
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
              <ul className="navbar-nav ms-auto mb-2 mb-md-0">
                <li className="nav-item">
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href="https://docs.google.com/forms/d/e/1FAIpQLSdPnDyK24Pa1aAXsGB9MF-6jeNdrUZig_or-_cvj7BqdMFeug/viewform?vc=0&c=0&w=1&flr=0"
                    className="nav-link"
                  >
                    <i
                      className="fa fa-file-contract me-2"
                      aria-hidden={true}
                    ></i>
                    APPLY FOR IDO
                  </a>
                </li>
                <li
                  className="nav-item ms-auto"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    width: "auto",
                  }}
                ></li>
              </ul>
            </div>
          </div>
        </nav> */}
        {this.props.state.connected ? (
          <div
            className="modal fade"
            id="accountInfo"
            data-bs-backdrop="static"
            data-bs-keyboard="true"
            tabIndex="-1"
            aria-labelledby="accountInfoLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title text-dark" id="accountInfoLabel">
                    Account
                  </h5>
                  <button
                    type="button"
                    className="btn-close me-2 text-dark"
                    style={{ border: "solid #1a1a1a 3px" }}
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <i className="fas fa-times"></i>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="card">
                    <div className="card-body">
                      <p className="text-dark">
                        Connected with{" "}
                        {this.props.state.provider != null &&
                        this.props.state.provider.hasOwnProperty("qrcode")
                          ? "WalletConnect"
                          : "MetaMask"}{" "}
                      </p>
                      <p
                        className="text-dark"
                        style={{
                          fontFamily: "monospace, sans-serif",
                          fontSize: "24px",
                        }}
                      >
                        <strong>
                          {this.formatAddress(this.props.state.account)}
                        </strong>
                      </p>
                      <p>
                        <button
                          className="btn btn-sm"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Copy address"
                          onClick={this.copyAddress}
                        >
                          <i className="fa fa-clone" aria-hidden></i> Copy
                          Address
                        </button>{" "}
                        <button
                          className="btn btn-sm"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="View on Explorer"
                          onClick={this.viewOnExplorer}
                        >
                          <i className="fa fa-external-link" aria-hidden></i>{" "}
                          View on Explorer
                        </button>
                      </p>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    className="btn btn-primary"
                    onClick={this.doDisconnect}
                    data-bs-dismiss="modal"
                  >
                    Disconnect
                  </button>
                  {/* <p>Your transactions will appear here.</p> */}
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  }
}

export default Header;
